import { store } from './store.redux';
import { GlobalPrivateState } from 'src/api';
import { userIsInternal } from 'src/app/Partials/Admin/utils';
import { ConfigurationModel } from 'franke-trough-dependencies';

// The idea of this file is to provide utility functions which always look at the state in the same way...
// I wasn't sure of another way to best achieve this... I didn't like connecting every state object and the objects into a function, and I didn't like wrapping everything in containers...
// This seemed like the simplest way to achieve what I wanted...

// WARNING - The issue with these methods is that they return the state variables at time of render... 
// Since the function is not "connect()"ed, if the function is called on a component that has no connection then it will not auto-update on state change and force re-render...
// I'm going to leave it like this because it currently works, perhaps somebody more knowledgeable than me will have a better solution

export const hasConfigurationOverlapError = (configuration?: ConfigurationModel): boolean => {
  const state: GlobalPrivateState = store.getState() as GlobalPrivateState;
  const currentConfiguration = configuration || state.configuration.result;

  if (!currentConfiguration || !state.plateBuilder || !state.plateBuilder.calc) {
    return false;
  }

  try {
    return state.plateBuilder.calc.hasOverlappingError();
  } catch (error) {
    return false;
  }
};

export const isConfigurationEditableByCurrentUser = (configuration?: ConfigurationModel): boolean => {
  const state: GlobalPrivateState = store.getState() as GlobalPrivateState;
  const order = state.order.result as any;

  if (!configuration) {
    configuration = state.configuration.result;
  }

  if (!configuration) {
    return false;
  }

  const configIsDraft = configuration.completionStatus === 'draft';
  const configIsRequest = configuration.completionStatus === 'request';
  const configIsOffer = configuration.completionStatus === 'offer';
  const configIsFailed = configuration.completionStatus === 'failed' || (order && order.error && order.error.message);
  const isInternalUser = state.user.result && userIsInternal(state.user.result) || false;


  // return (configIsDraft || (configIsRequest && isInternalUser));
  return (configIsDraft && !configIsFailed); // Note: also has to go up with back-end restrictions, just struggling with code merges... keeping in stash for now 'really-uneditable'
}

export const isConfigurationEditable = (configuration?: ConfigurationModel): boolean => {
  const state: GlobalPrivateState = store.getState() as GlobalPrivateState;

  const configResult = state.configuration.result || true;
  const configUpdating = state.configuration.updating || false;

  let hasOverlapWarning = false;
  if (state.configuration.result && state.plateBuilder) {
    const config = state.configuration && state.configuration.result;
    const hasOverlappingError = state.plateBuilder && state.plateBuilder.calc.hasConsoleOverlappingError();
    const hasMiranitConsoles = (config && config.assemblyAccessories && config.assemblyAccessories.console || config && config.defaults.assemblyAccessories.console.default) === 'miranit';
    const acceptedMiranitOverlap = config && config.assemblyAccessories && config.assemblyAccessories.acceptedMiranitOverlap;
    hasOverlapWarning = (hasOverlappingError && hasMiranitConsoles && !acceptedMiranitOverlap);
  }

  return !hasOverlapWarning && !hasConfigurationOverlapError(configuration) && configResult && !configUpdating && isConfigurationEditableByCurrentUser(configuration);
}
